import React, {useState} from 'react'
import {Button} from 'react-bootstrap'
import {useBatchApproval} from '../../../../../../context/BatchApprovalContext'
import {batchApproveIncomeDocuments} from '../../../../../../api/RevenueApi'
import {IncomeDocumentStateTypes} from '../../../../../../constants/Common'
import {useAuth} from '../../../../../auth'
import BatchApproveConfirmDialog from '../../../../../../components/app/BatchApproveConfirmDialog'

const UsersListGrouping = ({onDone = () => {}}: {onDone?: () => void}) => {
  const {selectedDocs, clearAll} = useBatchApproval()
  const {can} = useAuth()
  const [showDialog, setShowDialog] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [progress, setProgress] = useState<{done: number; total: number} | undefined>()

  const selectedList = Array.from(selectedDocs.values())

  if (!can('accounting_purchase_order_approve')) {
    return (
      <div className='d-flex justify-content-end align-items-center'>
        <span className='fw-bolder me-5 text-muted'>เลือก {selectedList.length} รายการ</span>
        <Button size='sm' variant='secondary' onClick={clearAll}>
          ล้างการเลือก
        </Button>
      </div>
    )
  }

  const handleBatchApprove = () => {
    setIsLoading(true)
    setProgress({done: 0, total: selectedList.length})
    const items = selectedList.map((doc) => ({
      id: doc.id,
      state: IncomeDocumentStateTypes.APPROVED,
    }))
    batchApproveIncomeDocuments(
      items,
      () => {
        setIsLoading(false)
        setProgress(undefined)
        setShowDialog(false)
        clearAll()
        onDone()
      },
      (done, total) => setProgress({done, total})
    ).catch(() => {
      setIsLoading(false)
      setProgress(undefined)
    })
  }

  return (
    <div className='d-flex justify-content-end align-items-center'>
      <span className='fw-bolder me-5'>เลือก {selectedList.length} รายการ</span>
      <Button
        size='sm'
        variant='primary'
        className='me-2'
        onClick={() => setShowDialog(true)}
        disabled={selectedList.length === 0}
      >
        อนุมัติที่เลือก ({selectedList.length})
      </Button>
      <Button size='sm' variant='secondary' onClick={clearAll}>
        ล้างการเลือก
      </Button>
      <BatchApproveConfirmDialog
        show={showDialog}
        docs={selectedList}
        onConfirm={handleBatchApprove}
        onCancel={() => setShowDialog(false)}
        isLoading={isLoading}
        progress={progress}
      />
    </div>
  )
}

export {UsersListGrouping}
